import { render, staticRenderFns } from "./TeacherGeneralForm.vue?vue&type=template&id=14e27685&scoped=true&"
import script from "./TeacherGeneralForm.vue?vue&type=script&lang=js&"
export * from "./TeacherGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./TeacherGeneralForm.vue?vue&type=style&index=0&id=14e27685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e27685",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VTextField})
